"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatHubUtils = void 0;
class ChatHubUtils {
    static CallIfFunction(fn, ...params) {
        if (typeof fn === 'function') {
            fn(...params);
        }
    }
}
exports.ChatHubUtils = ChatHubUtils;
//# sourceMappingURL=ChatHub.Utils.js.map